const menu = {
  1: {
    title: 'About',
    path: '/',
    icon: 'user-circle',
    iconType: 'fal',
    color: '',
  },
  2: {
    title: 'Skills',
    path: '/skills',
    icon: 'code',
    iconType: 'fal',
    color: '',
  },
  3: {
    title: 'Experience',
    path: '/experience',
    icon: 'briefcase',
    iconType: 'fal',
    color: '',
  },
  4: {
    title: 'Portfolio',
    path: '/portfolio',
    icon: 'folder',
    iconType: 'fal',
    color: '',
  },
}

export default menu
